<!-- 表二列表 -->

<template>
  <div class="ListCage table9">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 2-1：音像制品出版情况登记表</span>
      <span v-else>表 2-1：电子出版物出版情况登记表</span>
      <div class="tabBtns">
        <!-- <el-button type="primary" @click="memberEdit(1)" size="mini">添加</el-button> -->
        <!-- <a :href="excelModeUrl" download><el-button size="mini">下载模板</el-button></a> -->
        <el-button type="primary" style="width: 130px" @click="pullProductFromSystem" size="mini"
          >音电书号系统导入</el-button
        >
        <!-- <el-button @click="ExcelHandler" size="mini" type="primary">导入Excel</el-button> -->
        <a href="javascript:void(0);" @click="dmyfile(1)" download
          ><el-button size="mini" type="primary">导出Excel</el-button></a
        >
        <el-button size="mini" @click="goBack">返回</el-button>
        <ExcelIn
          ref="ExcelSet"
          @t-frash="goFresh"
          @excel-errors="errorCtrls"
          :pressId="querys.pressId"
          :mtId="querys.mtId"
          excelCode="301"
          :pressType="pressType" />
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="ctrlsLine">
      <el-radio-group v-model="yearSet" @change="tabSeek">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">{{ selYear - 2 }}年</el-radio>
        <el-radio :label="2">{{ selYear - 1 }}年</el-radio>
      </el-radio-group>
      <el-input v-model="seekPms.keyword" size="small" placeholder="通过出版物名称、专用书号查询"></el-input>
      <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
      <!-- <el-button class="dangerBtns" size="small" @click="memberDet(1)" type="warning">删除</el-button>
              <el-button class="dangerBtns" @click="memberClean" size="small" type="danger">清除全部</el-button> -->
    </div>
    <div class="table_tips">
      <p>注：此表内容只能从书号系统同步数据，规则为成品上传时间在两个核验年度中的全部出版物信息。</p>
      <!-- <p style="text-indent: 2em">数据录入完成之后，请点击“ISBN验重”按钮，检查是否有ISBN重复的情况。</p>
      <p style="text-indent: 2em">
        书号系统导入的数据为已经成书上传的数据，“是否中小学教材”和“是否中小学教辅”无法通过书号系统获取，默认为“否”。可以手动修改，也可以先导出Excel，修改后再导入Excel。
      </p> -->
    </div>
    <div class="tabArea">
      <el-table
        :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        border
        style="width: 100%"
        @selection-change="selectionChange"
        v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 20 * (currentPage - 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年份" width="90" align="center"> </el-table-column>
        <el-table-column prop="publicationName" label="出版物名称" width="180" align="center"> </el-table-column>

        <el-table-column prop="isbn" width="150" label="专用书号(ISBN 978-7-)" align="center"> </el-table-column>
        <el-table-column label="载体形式" width="90" align="center">
          <template slot-scope="scope">
            <div v-if="pressType == 1">
              {{ scope.row.carrierForm | translate("C010", dicMap, scope.row) }}
            </div>
            <div v-else-if="pressType == 2">
              {{ scope.row.carrierForm | translate("C025", dicMap, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="出版形式" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.publicationForm | translate("C011", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="productionUnit" label="节目来源/制作单位" width="120" align="center"> </el-table-column>
        <el-table-column prop="programCapacity" label="节目时长或容量(分钟/兆)" width="90" align="center">
        </el-table-column>
        <el-table-column prop="publicationQuantity" label="出版数量（张/盒）" width="90" align="center">
        </el-table-column>
        <!-- <el-table-column prop="issueQuantity" label="发行数量（张/盒）" width="90" align="center"> </el-table-column> -->
        <!-- <el-table-column prop="unitPrice" label="发行单价（元）" width="90" align="center"> </el-table-column> -->
        <el-table-column prop="publishingTime" label="出版时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishingTime | stringTrans("time") }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否缴送样本" align="center">
          <template slot-scope="scope">
            {{ scope.row.sampleDelivery | translate("C018", dicMap) }}
          </template>
        </el-table-column> -->
        <el-table-column label="是否书配盘标记" align="center">
          <template slot-scope="scope">
            {{ scope.row.sign | translate("C018", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="memberEdit(2, scope.row)" size="mini">编辑</el-button>
            <!-- <el-button type="danger" @click="memberDet(2, scope.row)" size="mini">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pageArea">
      <el-pagination
        v-if="allPage > 1"
        layout="prev, pager, next"
        @current-change="goPage"
        :current-page="seekPms.no"
        :page-count="allPage">
      </el-pagination>
    </div>

    <div class="headBar">
      <span>申报人信息</span>
    </div>
    <div class="editArea newEditArea">
      <div class="editBox">
        <p class="edName">申报人：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">联系方式：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">申报时间：</p>
        <div class="edInp">
          <el-input size="small" v-model="updatedAt" :disabled="true"></el-input>
        </div>
      </div>
      <div class="saveBtn">
        <el-button size="small" @click="goBack">返回</el-button>
        <el-button v-if="pubStatus == 0" type="primary" size="small" @click="postDeclareFun">保存</el-button>
      </div>
    </div>

    <ExError ref="chinldError" :errorList="excelEr" pressCode="301"></ExError>
  </div>
</template>

<script>
import initPagin from "@/mixins/initPagin";
import { tabList9, tab9Remove, tab9Clean, submitDeclare, tb9PullProductFromSystem } from "@/api/pressRole/pressRole";
import { expFile } from "@/api/export";
import ExcelIn from "@/views/components/excelRead/excel";
import ExError from "@/views/components/excelRead/excelError";
export default {
  mixins: [initPagin],
  components: {
    ExcelIn,
    ExError,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      querys: {
        pressId: "",
        mtId: "",
      },

      loading: false,
      excelEr: [],

      tabDat: [],
      detArrs: [],
      dicMap: {},

      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15,
      },
      allPage: 0,

      excelModeUrl: "",
      excelExportUrl: "",
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",
      pubStatus: 0,

      selYear: new Date().getFullYear(),

      currentPage: 1,
    };
  },
  filters: {
    translate: function (dat, code, transMap, rowDat) {
      if (code == "C010" || code == "C025") {
        if (transMap[code][dat] == "其他") {
          return rowDat.carrierFormQT;
        } else {
          return transMap[code][dat];
        }
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function (dat, code) {
      if (dat != null && code == "time") {
        let timeStr = dat.substr(0, 10);
        return timeStr;
      }
      return dat;
    },
  },
  methods: {
    // zym.对接音电书号系统，将数据迁移过来
    pullProductFromSystem: function () {
      let publishMaterialId = this.$route.query.mtId;
      let tipType = "音像制品出版情况登记表";
      if (this.pressType == "2") {
        tipType = "电子出版物出版情况登记表";
      }
      let tipMsg =
        `<span>导入音电书号系统中已成品上传的音电数据，导入前会<span style='font-weight:bold;color:red'>删除所有` +
        tipType +
        `中的数据</span>，如果已经执行过导入，请谨慎操作，是否继续?</span>`;
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          var dataIn = {};
          dataIn.publishMaterialId = publishMaterialId;

          const loading = this.$loading({
            lock: true,
            text: "导入中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          tb9PullProductFromSystem(dataIn).then((response) => {
            console.log("response=", response);
            let code = (response || {}).code;
            let msg = (response || {}).message || "导入失败";
            if (code == 0) {
              this.tabSeek();
              loading.close();
              this.$message({
                type: "success",
                message: msg,
              });
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导入",
          });
        });
    },
    tabSeek: function (type) {
      let that = this;
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = this.selYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = this.selYear - 1;
      }
      let vm = this;

      var page = sessionStorage.getItem("toPage"); // 手动加的，用于跳转到指定页
      if (page && page > 0) {
        this.currentPage = +page; // 0+page 转数字的方式
        sessionStorage.removeItem("toPage");
        sessionStorage.removeItem("fromPage");
      }

      tabList9(this.seekPms).then((response) => {
        vm.tabDat = [];
        let pages = 1;

        if (response.ppublicationList.length > 0) {
          // 近两年的申报 奇数年是1年 偶数年是2年
          let dummyYear = response.ppublicationList[0].year;
          console.log("response.ppublicationList[0]=", JSON.stringify(response.ppublicationList[0]));
          if (dummyYear % 2 == 0) {
            vm.selYear = dummyYear * 1 + 1;
          } else {
            vm.selYear = dummyYear * 1 + 2;
          }
          pages = parseInt(response.ppublicationList.length / that.pageSize);
          if (response.ppublicationList.length % that.pageSize > 0) {
            pages += 1;
          }
        }

        setTimeout(function () {
          for (let item of response.ppublicationList) {
            if (!(item.publicationName == "无" && item.isbn == "无")) {
              vm.tabDat.push(item);
            }
          }
          vm.loading = false;
          vm.allPage = pages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function (type, dat) {
      let params = {};
      let message = "确认删除所有选中项吗？";

      if (type == 1) {
        params.ids = this.detArrs;
      } else if (type == 2) {
        params.ids = [dat.id];
        message = "确认删除吗？";
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        params.publishMaterialId = this.$route.query.mtId;
        tab9Remove(params)
          .then((response) => {
            this.tabSeek();
          })
          .catch((error) => {});
      });
    },
    memberClean: function () {
      this.$confirm("此操作会删除所有出版物信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tab9Clean({
            publishMaterialId: this.$route.query.mtId,
          }).then((response) => {
            this.tabSeek();
          });
        })
        .catch(() => {});
    },
    selectionChange: function (selection) {
      let newArr = [];
      for (let i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function () {
      let nameArr = ["C010", "C011", "C018", "C012", "C025"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map",
      });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    memberEdit: function (type, dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus,
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      sessionStorage.setItem("fromPage", this.currentPage);
      this.$router.push({
        path: "edit_tab9",
        query: pathParams,
      });
    },

    ExcelHandler: function () {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function (val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goBack: function () {
      this.$router.go(-1);
    },

    goFresh: function () {
      this.yearSet = 0;
      this.seekPms.year = "";
      this.seekPms.keyword = "";
      this.tabSeek("init");
    },

    goPage: function (inx) {
      // this.seekPms.no = inx;
      // this.tabSeek();
      this.currentPage = inx;
    },

    errorCtrls: function (val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function () {
      let that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('申报人手机号格式错误');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      submitDeclare({
        // hsj.手动加code，统一模组化
        code: "301",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare,
      })
        .then((response) => {
          let tipCode = response.payload.code;
          let tipMessage = response.payload.message;

          that.submiting = false;
          if (tipCode == -1) {
            that.$message.error(`保存错误: ${tipMessage}`);
            return;
          }
          that.$message({
            message: "保存成功！",
            type: "success",
          });

          that.goBack();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterData: function (data, params) {
      let text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();

      let list = _.filter(data, (x) => {
        // if (params.type !=0 && x.type != params.type) return false
        return (
          ((x.publicationName && x.publicationName.includes(text)) || (x.isbn && x.isbn.includes(text))) &&
          (params.year == 0 || x.year == params.year)
        );
      });

      let pages = parseInt(list.length / this.pageSize);
      if (list.length % this.pageSize > 0) {
        pages += 1;
      }

      if (pages == 0) {
        return [];
      }

      this.allPage = pages;
      if (this.currentPage > this.allPage) {
        this.currentPage = 1;
      }

      // 没起到实际作用，但是刷新回来的时候靠这个显示
      if (this.seekPms.no != this.currentPage) {
        this.seekPms.no = this.currentPage;
      }
      return list;
    },
    dmyfile: function (exp) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printYxdzCbwList";
        params = {
          type: this.querys.pressType,
          year: this.seekPms.year,
          publishMaterialId: this.$route.query.mtId,
        };
      }
      expFile({
        expUrl: expUrl,
        p: params,
      })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
  },
  created: function () {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      mtId: this.$route.query.mtId,
    };

    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;

    if (this.querys.pressType == 1) {
      //this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=3011&token=' + encodeURIComponent(this.$store.getters.token);
      this.excelModeUrl = process.env.URL_FILE + "/drmb/3011.xlsx";
    } else {
      //this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=3012&token=' + encodeURIComponent(this.$store.getters.token);
      this.excelModeUrl = process.env.URL_FILE + "/drmb/3012.xlsx";
    }

    this.excelExportUrl =
      process.env.URL_FILE +
      "/File/File/printYxdzCbwList?type=" +
      this.querys.pressType +
      "&publishMaterialId=" +
      this.$route.query.mtId +
      "&token=" +
      encodeURIComponent(this.$store.getters.token);
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleL";
.table_tips {
  color: red;
  font-size: 14px;
}
.table9 .el-radio + .el-radio {
  margin-left: 20px;
}

.table9 .ctrlsLine .el-input {
  display: inline-block;
  width: 360px;
  margin-left: 20px;
}

.table9 .tabBtns .el-button + .el-button {
  margin-left: 0;
}

.table9 .pageArea {
  text-align: center;
  padding: 30px 0px;
}

.table9 .ctrlsLine .tips {
  font-size: 12px;
  margin-top: 12px;
  color: salmon;
}

.table9 {
  .saveBtn {
    margin: 30px 200px;

    .el-button {
      width: 150px;
      margin-right: 10px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table9.vue?31a03f04